export default "__VITE_ASSET__DYin4t_l__"